export default "__VITE_ASSET__BwXzQm7c__"